$(document).ready(function () {
  try {
    $('.tab--listing .tab--header').on('click', function () {
      var $this = $(this);
      $this.toggleClass('active');
      $this.next().slideToggle();
    });
  } catch (e) {
    Rollbar.error('accordian js', e);
  }
});
